<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M27 7v18a2 2 0 01-2 2H7a2 2 0 01-2-2V7a2 2 0 012-2h18a2 2 0 012 2zm-15.08 3.41a1.69 1.69 0 00-.52-1.23 1.84 1.84 0 00-1.33-.48 1.92 1.92 0 00-1.35.48 1.63 1.63 0 00-.53 1.23 1.64 1.64 0 00.51 1.23 1.82 1.82 0 001.33.49 1.86 1.86 0 001.36-.49 1.62 1.62 0 00.53-1.23zm-3.53 13h3.31v-9.93H8.39zm11.91 0h3.3v-5.7a4.76 4.76 0 00-1-3.34 3.6 3.6 0 00-2.76-1.13 3.34 3.34 0 00-3 1.68v-1.44h-3.32v9.94h3.31v-5.56a2.28 2.28 0 01.1-.8 2.16 2.16 0 01.65-.85 1.56 1.56 0 011.06-.35c1.1 0 1.66.75 1.66 2.25z"/></svg>